import boilerplateMessageFr from './boilerplate/fr-FR';
import boilerplateMessageEn from './boilerplate/en-US';
import homeMessageFr from './home/fr-FR';
import actionplansMessageFr from './actionplans/fr-FR';
import propertiesMessageFr from './properties/fr-FR';
import properties360MessageFr from './properties_360/fr-FR';
import logbooksMessageFr from './logbook/fr-FR';
import actionsMessageFr from './actions/fr-FR';
import userExchangesMessageFr from './user_exchanges/fr-FR';
import requestsMessageFr from './requests/fr-FR';
import techSearchMessageFr from './tech_search/fr-FR';
import attachementsMessageFr from './attachements/fr-FR';
import alertsMessageFr from './alerts/fr-FR';
import authorsMessageFr from './authors/fr-FR';
import instructionsMessageFr from './instructions/fr-FR';
import dashboardMessageFr from './dashboard/fr-FR';
import dashboardDispatcherMessageFr from './dashboardDispatcher/fr-FR';
import dashboardPemMessageFr from './dashboardPem/fr-FR';
import homeMessageEn from './home/en-US';
import sensorsMessageFr from './sensors/fr-FR';
import heatingSetupParamsFr from './heatingSetupParams/fr-FR';
import regulatoryControlsFr from './regulatoryControls/fr-FR';
import fr from './fr-FR';
import en from './en-US';

const messages = {
  fr: {
    message: {
      boilerplate: boilerplateMessageFr,
      home: homeMessageFr,
      actionplans: actionplansMessageFr,
      properties: propertiesMessageFr,
      properties_360: properties360MessageFr,
      actions: actionsMessageFr,
      logbook: logbooksMessageFr,
      user_exchanges: userExchangesMessageFr,
      requests: requestsMessageFr,
      tech_search: techSearchMessageFr,
      attachements: attachementsMessageFr,
      alerts: alertsMessageFr,
      authors: authorsMessageFr,
      instructions: instructionsMessageFr,
      dashboard: dashboardMessageFr,
      dashboardDispatcher: dashboardDispatcherMessageFr,
      dashboardPem: dashboardPemMessageFr,
      sensors: sensorsMessageFr,
      heatingSetupParams: heatingSetupParamsFr,
      regulatoryControls: regulatoryControlsFr,
      ...fr.message,
    },
    route: fr.route,
  },
  en: {
    message: {
      boilerplate: boilerplateMessageEn,
      home: homeMessageEn,
      ...en.message,
    },
    route: en.route,
  },
};

export default messages;
